exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css);", ""]);

// module
exports.push([module.id, "label{font-size:2em}input[type=checkbox]{display:none}input[type=checkbox]+label:before{font-family:FontAwesome;display:inline-block;content:\"\\F096\";letter-spacing:10px}input[type=checkbox]:checked+label:before{content:\"\\F046\";letter-spacing:5px}._3LHwA9MTHqqQHJ-88sQrX8{position:absolute;z-index:999;background-color:hsla(0,0%,100%,.93);left:10%;border:2px solid #f5f5f5;display:inline-block;padding:1.7em 4em 3em;border-radius:3px;margin:2em}._3LHwA9MTHqqQHJ-88sQrX8 h1{font-size:2.5em}._3fcLZWOmqlAvLfEsPlANyj{margin-bottom:.5em}", ""]);

// exports
exports.locals = {
	"guestList": "_3LHwA9MTHqqQHJ-88sQrX8",
	"guestName": "_3fcLZWOmqlAvLfEsPlANyj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/postcss-loader!./src/styles/guest-list.css
// module id = 123
// module chunks = 0